export default __webpack_public_path__ + "static/media/bliBliLogo.ece69b8c.png";